type Props = {
  width?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: number;
};

export const Close = ({ width = 10, height = 10, stroke = 'black', strokeWidth = 1.5 }: Props) => (
  <svg width={width} height={height} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L8 8M1 8L8 1" stroke={stroke} strokeWidth={strokeWidth} />
  </svg>
);
